import { ActivatedRouteSnapshot } from '@angular/router';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { SupplierModel } from './supplier.model';
import { SupplierService } from './supplier.service';

@Injectable({
  providedIn: 'root',
})
export class SupplierResolver {
  constructor(private service: SupplierService) {}

  resolve(route: ActivatedRouteSnapshot): Observable<SupplierModel> {
    return this.service.getById(route.paramMap.get('id') || '').pipe(map((supplier) => supplier.data));
  }
}
